import {State, Action, StateContext, Selector, Store} from '@ngxs/store';
import {Alert} from 'app/models/dto/alert.model';
import {of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import { ResendAdditionalOwnerInvites, ResendAdditionalOwnerPostOfferVerification } from './additional-owner.actions';
import {Injectable} from '@angular/core';
import {AdditionalOwnerInvitesService} from 'app/services/additional-owner/additional-owner-invites.service';
import { CreateContactAlert } from 'ng2-app/store/contact/contact.actions';

export class AdditionalOwnerStateModel {
  saving: {
    saving: boolean;
  };
  alerts: Alert[];
}

@State<AdditionalOwnerStateModel>({
  name: 'additionalOwner',
  defaults: {
    saving: {saving: false},
    alerts: [],
  }
})

@Injectable()

export class AdditionalOwnerState {

  @Selector()
  static saving(state: AdditionalOwnerStateModel) {
    return state.saving;
  }

  @Selector()
  static alerts(state: AdditionalOwnerStateModel) {
    return state.alerts;
  }

  constructor(
    private additionalOwnerService: AdditionalOwnerInvitesService,
    private store: Store
  ) {
  }

  @Action(ResendAdditionalOwnerInvites)
  resendAdditionalOwnerInvites({
                                 getState,
                                 patchState
                               }: StateContext<AdditionalOwnerStateModel>, {borrowerId}: ResendAdditionalOwnerInvites) {
    patchState({saving: {saving: true}});
    return this.additionalOwnerService.resendAdditionalOwnerInvites(borrowerId).pipe(catchError(err => {
      const newAlert: Alert = {
        level: 'error',
        message: err.message ? err.message : 'Not able to resend request, please try again.',
        dismissDelay: 5000
      };
      patchState({
        alerts: [...getState().alerts, newAlert],
        saving: {saving: false}
      });
      this.store.dispatch(new CreateContactAlert(newAlert));
      return of();
    }), tap(() => {

      const newAlert: Alert = {
        level: 'success',
        message: 'Request was resent to all owners.',
        dismissDelay: 5000
      };
      patchState({
        alerts: [...getState().alerts, newAlert],
        saving: {saving: false}
      });
      this.store.dispatch(new CreateContactAlert(newAlert));
    }));
  }

  @Action(ResendAdditionalOwnerPostOfferVerification)
  resendAdditionalOwnerPostOfferVerification({getState, patchState}: StateContext<AdditionalOwnerStateModel>,
                                             {borrowerId}: ResendAdditionalOwnerPostOfferVerification) {
    patchState({saving: {saving: true}});
    return this.additionalOwnerService.resendAdditionalOwnerPostOfferVerification(borrowerId).pipe(catchError(err => {

      const newAlert: Alert = {
        level: 'error',
        message: err.message ? err.message : 'Not able to resend pre-funding verification link, please try again.',
        dismissDelay: 5000
      };

      patchState({
        alerts: [...getState().alerts, newAlert],
        saving: {saving: false}
      });

      this.store.dispatch(new CreateContactAlert(newAlert));
      return of();
    }), tap(() => {

      const newAlert: Alert = {
        level: 'success',
        message: 'Request was resent to all owners.',
        dismissDelay: 5000
      };

      patchState({
        alerts: [...getState().alerts, newAlert],
        saving: {saving: false}
      });

      this.store.dispatch(new CreateContactAlert(newAlert));
    }));
  }

}
